import { BehaviorSubject } from 'rxjs';

class MenuFactory{
    state = new BehaviorSubject(false)
    get = () => this.state.asObservable()
    toggle = () => this.state.next(!this.state.value)
    open = () => this.state.next(true)
    close = () => this.state.next(false)
}

export const MenuController = new MenuFactory()